var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBmo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0037 28.0062V24.7262M24.0037 28.0062C20.6704 28.0062 17.3377 27.6422 14.0057 26.9142M24.0037 28.0062C27.337 28.0062 30.6704 27.6422 34.0037 26.9142M14.0057 26.9142C11.4007 26.3395 8.84384 25.5652 6.35769 24.5982C5.33769 24.2062 4.82769 24.0082 4.47769 23.5582C3.89769 22.8102 4.00369 21.7682 4.00369 20.8782C4.00369 18.4122 4.00369 15.1762 4.60369 14.5322C5.74369 13.3122 7.91769 14.4362 9.18369 14.8462C19.0637 18.0502 28.9437 18.0502 38.8237 14.8462C40.0877 14.4362 42.2637 13.3142 43.4017 14.5322C44.0017 15.1762 44.0017 18.4122 44.0017 20.8782C44.0017 22.1142 44.0017 22.7322 43.7317 23.2442C43.3117 24.0282 42.4317 24.2982 41.6497 24.6002C39.1641 25.5657 36.6079 26.3407 34.0037 26.9142M14.0057 26.9142L14.0037 23.6302M34.0037 26.9142V23.6302M38.0037 38.0202C28.6704 40.6922 19.337 40.6922 10.0037 38.0202",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3822 5.99609C37.2282 8.61809 36.1682 13.1161 36.1682 15.1761M9.63021 5.99609C10.7842 8.61809 11.8462 13.1161 11.8462 15.1761M10.7982 31.0221C9.92021 33.7821 7.60221 39.2421 8.00821 42.0061M37.2282 31.0221C38.1082 33.7821 40.4262 39.2421 40.0182 42.0061",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmo);
export default __webpack_public_path__ + "static/media/bmo.4c56768d30ca3149ca29cf2716d561a3.svg";
export { ForwardRef as ReactComponent };